import React, { Component } from 'react';
import Displaceskn from './displaceskn';

/**
 *  置换 skn
 */
export class DisplaceSkn extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { row, entity } = this.props;
        return (
            <div>
                <Displaceskn rows={row} entity={entity} />
            </div>
        );
    }
}
